var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Form",
        {
          ref: "addForm",
          attrs: {
            model: _vm.addForm,
            "label-width": 150,
            "label-colon": "",
            rules: _vm.ruleValidateType2,
          },
        },
        [
          _vm.addForm.namePath
            ? _c(
                "FormItem",
                {
                  attrs: {
                    label: _vm.$t("deviceSip.prevArea"),
                    prop: "namePath",
                    required: "",
                  },
                },
                [
                  _c("Input", {
                    attrs: {
                      size: "large",
                      type: "textarea",
                      autosize: { minRows: 1, maxRows: 5 },
                      clearable: "",
                      disabled: "",
                    },
                    model: {
                      value: _vm.addForm.namePath,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "namePath", $$v)
                      },
                      expression: "addForm.namePath",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "FormItem",
            { attrs: { label: _vm.$t("area.areaNameTop"), prop: "nameTop" } },
            [
              _c("Input", {
                attrs: {
                  size: "large",
                  maxlength: 20,
                  placeholder: _vm.$t("area.areaJoinHold"),
                  clearable: "",
                },
                model: {
                  value: _vm.addForm.nameTop,
                  callback: function ($$v) {
                    _vm.$set(_vm.addForm, "nameTop", $$v)
                  },
                  expression: "addForm.nameTop",
                },
              }),
            ],
            1
          ),
          _c(
            "FormItem",
            { attrs: { label: _vm.$t("area.areaNameLast"), prop: "nameLast" } },
            [
              _c("Input", {
                attrs: {
                  size: "large",
                  maxlength: 20,
                  placeholder: _vm.$t("area.areaJoinHold1"),
                  clearable: "",
                },
                model: {
                  value: _vm.addForm.nameLast,
                  callback: function ($$v) {
                    _vm.$set(_vm.addForm, "nameLast", $$v)
                  },
                  expression: "addForm.nameLast",
                },
              }),
            ],
            1
          ),
          _c(
            "FormItem",
            { attrs: { prop: "startNum", label: _vm.$t("area.startNum") } },
            [
              _c("Input", {
                attrs: {
                  size: "large",
                  maxlength: 4,
                  placeholder: _vm.$t("area.areaNumHold"),
                  clearable: "",
                },
                model: {
                  value: _vm.addForm.startNum,
                  callback: function ($$v) {
                    _vm.$set(_vm.addForm, "startNum", $$v)
                  },
                  expression: "addForm.startNum",
                },
              }),
            ],
            1
          ),
          _c(
            "FormItem",
            { attrs: { prop: "endNum", label: _vm.$t("area.endNum") } },
            [
              _c("Input", {
                attrs: {
                  size: "large",
                  maxlength: 4,
                  placeholder: _vm.$t("area.areaNumHold"),
                  clearable: "",
                },
                model: {
                  value: _vm.addForm.endNum,
                  callback: function ($$v) {
                    _vm.$set(_vm.addForm, "endNum", $$v)
                  },
                  expression: "addForm.endNum",
                },
              }),
            ],
            1
          ),
          _c(
            "FormItem",
            { attrs: { prop: "groupCall" } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _c("span", { staticClass: "error-color" }, [_vm._v("*")]),
                _vm._v(" " + _vm._s(_vm.$t("updateNewSip.groupCall")) + " "),
              ]),
              _c("i-switch", {
                staticClass: "margin-right-10",
                attrs: { "true-value": 1, "false-value": 0, size: "large" },
                model: {
                  value: _vm.addForm.groupCall,
                  callback: function ($$v) {
                    _vm.$set(_vm.addForm, "groupCall", $$v)
                  },
                  expression: "addForm.groupCall",
                },
              }),
              _c(
                "Poptip",
                {
                  attrs: {
                    trigger: "hover",
                    title: _vm.$t("deviceSip.note"),
                    placement: "right-top",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "content",
                      fn: function () {
                        return [
                          _c("h4", { staticClass: "call-tip-box" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("updateNewSip.groupCallTip")) +
                                " "
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("Icon", {
                    attrs: {
                      type: "md-help-circle",
                      size: "24",
                      color: "#FFB22B",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "FormItem",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    (_vm.addForm.nameTop || _vm.addForm.nameLast) &&
                    _vm.addForm.startNum,
                  expression:
                    "(addForm.nameTop || addForm.nameLast) && addForm.startNum",
                },
              ],
              attrs: { label: _vm.$t("area.areaNameTest") },
            },
            [
              _c("span", { staticStyle: { color: "#ed4014" } }, [
                _vm._v(
                  _vm._s(
                    _vm.addForm.nameTop +
                      _vm.addForm.startNum +
                      _vm.addForm.nameLast
                  )
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "detailBackBtn" },
        [
          _c(
            "Button",
            { attrs: { size: "large" }, on: { click: _vm.closeModal } },
            [_vm._v(_vm._s(_vm.$t("common.cancel")))]
          ),
          _c(
            "Button",
            {
              directives: [{ name: "debounce", rawName: "v-debounce" }],
              attrs: { type: "primary", size: "large", loading: _vm.spinShow },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.ensure")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content_win" },
        [
          _c("modal", {
            ref: "resultModal",
            attrs: { type: _vm.modalType },
            on: { afterComfirm: _vm.closeModal },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }